import { render, staticRenderFns } from "./TicketDetailsPanel.vue?vue&type=template&id=3ab741d3&"
import script from "./TicketDetailsPanel.vue?vue&type=script&lang=js&"
export * from "./TicketDetailsPanel.vue?vue&type=script&lang=js&"
import style0 from "./TicketDetailsPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports